export default __webpack_public_path__ + "static/media/ineos.9bd25f80.svg";